import { z } from 'zod';

export const restrictionTypeOptions = ['allow', 'avoid', 'warn'] as const;
export const restrictionZoneOptions = [
  'congestionZones',
  'environmentalZones',
] as const;

const restrictionZoneSchema = z.enum(restrictionZoneOptions);
const restritionOptionSchema = z.enum(restrictionTypeOptions);

export const restrictionZonesSchema = z.object({
  allow: z.array(restrictionZoneSchema).nullable(),
  avoid: z.array(restrictionZoneSchema).nullable(),
  warn: z.array(restrictionZoneSchema).nullable(),
});

export type RestrictionZoneType = z.infer<typeof restrictionZoneSchema>;
export type RestrictionOptionType = z.infer<typeof restritionOptionSchema>;
